export const wrapCell = (value) => {
  return <div style={{ whiteSpace: "normal" }}>{value}</div>;
};

export const NoteCell = (value) => {
  return <span style={{ whiteSpace: "normal" }}>{value}</span>;
};
